import { ElementInterface } from '@app/core/interfaces';
import { ApiRelationCodeEnum, mapRelationCodeResponse, RelationCodeEnum } from 'outshared-lib';

export interface ChangeDriverElementInterface {
    contentId: RelationCodeEnum;
    contentDescription: string;
}

// Inhoud_id type is string but needs to be RelationCodeEnum
export function mapChangeDriverElements(response: ElementInterface): ChangeDriverElementInterface[] {
    if (!response) {
        return [];
    }

    return response.inhoud.map((element) => ({
        contentDescription: element.inhoud_omschrijving,
        contentId: mapRelationCodeResponse(element.inhoud_id as ApiRelationCodeEnum),
    }));
}
